import {
  activityIdStorage,
  activityReflectionStorage,
  reflectionStorage,
  schoolIdStorage,
  activitySchoolIdStorage,
  store,
} from '@/store'
import { Modal } from '@seiue/ui'
import { authApi } from 'packages/sdks-next/growp'
import { getUrlParams } from 'packages/utils'

/**
 * 判断 access token 是否失效
 *
 * @param expiredAt -失效日期
 * @returns boolean
 */
export const isTokenDying = (expiredAt?: string) => {
  if (!expiredAt) return true
  const now = new Date().getTime()
  const expired = new Date(expiredAt).getTime()
  return now > expired
}

/**
 * 获取教师管理界面的 accessToken
 *
 * @returns accessToken
 */
export const getAdminOAuthInfoFn = () => async () => {
  const reflection = store.get(reflectionStorage)
  const _schoolId = getUrlParams('_school_id', location.search)
  const _refreshProxyToken = getUrlParams(
    '_refresh_proxy_token',
    location.search
  )

  if (_schoolId !== null && _refreshProxyToken !== null) {
    const { data } = await authApi.authRefreshToken(
      {
        refreshToken: _refreshProxyToken,
      },
      { omitAuthorizationHeader: true }
    )

    store.set(reflectionStorage, data)

    store.set(schoolIdStorage, Number(_schoolId))
    location.href = '/'
    return { tokenType: '', accessToken: data.token }
  }

  const schoolId = store.get(schoolIdStorage)

  if (!reflection) {
    return
  }

  if (!isTokenDying(reflection.expiredAt))
    return { tokenType: '', accessToken: reflection.token || '' }
  const href = `/login/${reflection.schoolId || schoolId}`
  try {
    const { data: isRefreshNotTokenDying } = await authApi.checkRefreshToken(
      {
        refreshToken: reflection.refreshToken || '',
      },
      { omitAuthorizationHeader: true }
    )

    // 如果 refreshToken 失效，直接跳转到登录界面
    if (!isRefreshNotTokenDying) {
      Modal.warning({
        title: '您的登录信息已过期',
        content: '请重新登录您的账号。',
        onOk: () => {
          store.set(reflectionStorage, undefined)
          location.href = href
        },
      })

      return
    }
  } catch (e) {
    Modal.warning({
      title: '网络错误',
      content: '请重新登录您的账号。',
      onOk: () => {
        store.set(reflectionStorage, undefined)
        location.href = href
      },
    })

    throw e
  }

  try {
    const { data } = await authApi.authRefreshToken(
      {
        refreshToken: reflection.refreshToken || '',
      },
      { omitAuthorizationHeader: true }
    )

    store.set(reflectionStorage, data)
  } catch (e) {
    Modal.warning({
      title: '网络错误',
      content: '请重新登录您的账号。',
      onOk: () => {
        store.set(reflectionStorage, undefined)
        location.href = href
      },
    })

    throw e
  }

  const user = store.get(reflectionStorage)

  if (!user?.token) {
    location.href = href
    return
  }

  return { tokenType: '', accessToken: user.token || '' }
}

/**
 * 获取前台界面的 accessToken
 *
 * @returns accessToken
 */
export const getUserOAuthInfoFn = () => async () => {
  const reflection = store.get(activityReflectionStorage)
  const schoolId = store.get(activitySchoolIdStorage)
  const activityId = store.get(activityIdStorage)
  if (!reflection) {
    return
  }

  if (!isTokenDying(reflection.expiredAt))
    return { tokenType: '', accessToken: reflection.token || '' }
  const href =
    !schoolId && !reflection.schoolId
      ? '/404'
      : `/login?schoolId=${
          reflection.schoolId || schoolId
        }&activityId=${activityId}`

  try {
    const { data: isRefreshNotTokenDying } = await authApi.checkRefreshToken(
      {
        refreshToken: reflection.refreshToken || '',
      },
      { omitAuthorizationHeader: true }
    )

    // 如果 refreshToken 失效，直接跳转到登录界面
    if (!isRefreshNotTokenDying) {
      Modal.warning({
        title: '您的登录信息已过期',
        content: '请重新登录您的账号。',
        onOk: () => {
          store.set(activityReflectionStorage, undefined)
          location.href = href
        },
      })

      return
    }
  } catch (e) {
    Modal.warning({
      title: '网络错误',
      content: '请重新登录您的账号。',
      onOk: () => {
        store.set(activityReflectionStorage, undefined)
        location.href = href
      },
    })

    throw e
  }

  try {
    const { data } = await authApi.authRefreshToken(
      {
        refreshToken: reflection.refreshToken || '',
      },
      { omitAuthorizationHeader: true }
    )

    store.set(activityReflectionStorage, data)
  } catch (e) {
    Modal.warning({
      title: '网络错误',
      content: '请重新登录您的账号。',
      onOk: () => {
        store.set(activityReflectionStorage, undefined)
        location.href = href
      },
    })

    throw e
  }

  const user = store.get(activityReflectionStorage)

  if (!user?.token) {
    location.href = href
    return
  }

  return { tokenType: '', accessToken: user.token || '' }
}
